var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"site-footer-wrapper"},[_c('TenantContent',{attrs:{"region":"before-footer"}}),_c('div',{staticClass:"site-footer"},[(_vm.content)?_c('TixTemplate',{staticClass:"site-footer-inner",attrs:{"template":_vm.content}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }